/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    publishData : null,
};


const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.PublishAction.REQUEST_PUBLISH_DATA:
      return {
        ...state,
    };
    case actions.PublishAction.PUBLISH_DATA_RECEIVED:
          return{
      ...state,
      publishData : action.data,
    };

    default:
      return state;
  }
};

export default reducer;
